import { createContext, FC, useCallback, useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import css from './index.module.less'; 
import { QuestionCircleOutline, StarFill, UserCircleOutline, DownOutline, UpOutline, TeamFill } from 'antd-mobile-icons'
import { AutoCenter, Button, Collapse, DotLoading, Toast } from 'antd-mobile'
import { actionTypes, useStoreDispatch, useStoreState } from '@/store'
import { getOrderListApi, getRoleGameListApi } from '@/api/home'
import { Link } from 'react-router-dom'
import { withAuth } from '@/hoc/withAuth'
import { BtnEval, BtnEvalNew, BtnReply } from '@/pages/user/My/components/EvalModal'
import InfiniteScrollTem from '@/components/InfiniteScrollContent'
import { useNav } from '@/hooks/useNav'
import { useAliveController } from 'react-activation'
import { workRead } from '@/api/user'

// 用来在评价弹框调用setOrderList进行更新
export const UpdateOrderContext = createContext(null);

export const My: FC = withAuth(props => {
  const { t } = useTranslation();
  const { role }: any = useStoreState();
  //const [activeGameCode, setActiveGameCode] = useState<string>('');
  const [gameList, setGameList] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, size: 20 });
  const [hasMore, setHasMore] = useState(false);
  const [unlogin, setUnloginState] = useState(false);
  const dispatch = useStoreDispatch();
  const { nav, genLink } = useNav()
  const aliveController = useAliveController()

  // 初始化获取分类列表
  useEffect(() => {
    const getRoleGameList = async () => {
      const res = await getRoleGameListApi()
      if (res?.code === 0) {
        res.data.unshift({ gameCode: "", gameName: `${t('user-center.all-order')}` })
        setGameList(res.data);
      }
    }
    getRoleGameList();

    setUnloginState(sessionStorage.getItem('unlogin') === 'yes' ? true : false)
    //setActiveGameCode(role.gameCode || '')
  }, [])

  // 获取工单列表
  const getOrderList = async () => {
    const res = await getOrderListApi({
      gameCode: role.gameCode,
      ...pagination
    }).finally(() => setLoading(false))
    if (res?.code === 0) {
      setOrderList(prevState => ([...prevState, ...res.data.records]));
      setPagination(prevState => ({ ...prevState, current: prevState.current + 1 }));
      setHasMore(res.data.current < res.data.pages);
    }
  }

  // 处理红点数据
  const dealRedDotData = (id: number) => {
    const newList = orderList.map(item => {
      if (item.id === id) {
        return { ...item, unRead: 1 };
      }
      return item;
    });
    setOrderList(newList);
  }

  // 更新激活的tab则重新刷新工单列表
  useEffect(() => {
    setLoading(true)
    setOrderList([])
    getOrderList()
  }, []);

  // 点击tab 更新分页和游戏
  /* const onTabClick = value => {
    setActiveGameCode(value)
    setPagination(prevState => ({ ...prevState, current: 1 }))
  }
  */

  // 点击退出登录 清空token和role 重定向到首页 然后清空之前缓存的页面和清空store
  const onBtnLogoutClick = useCallback(async () => {
    localStorage.removeItem('token')
    localStorage.removeItem('role')
    Toast.show({ icon: 'success', content: `${t('user-center.out-login-suc')}` })
    nav(`/`)
    await aliveController.clear()
    dispatch({ type: actionTypes.LOGOUT })
  }, [])


  return (
    <UpdateOrderContext.Provider value={setOrderList}>
      <div className={css.Page}>

        <div className={`${css.PageHd} ${process.env.REACT_APP_IDN_ENV === 'hw' ? css.hwPageHd : ''}`}>
          <div className={css.HdL}>
            {
              process.env.REACT_APP_IDN_ENV === 'hw' ? <TeamFill className={css.HdLIcon} /> : <UserCircleOutline className={'font-16'} />
            }
            {role?.roleName ? (
              <><span className={'mgl-5'}>{role.gameName}</span><span className={'mgl-5'}>{role.serverId}</span><span className={'mgl-5'}>{role.roleName}</span></>
            ) : <span className={'mgl-5 font-13'}>{t('user-center.select-role-tips')}</span>}
          </div>
          <div className={css.HdR}>
            <Link className={`${css.SelectRoleLink} ${process.env.REACT_APP_IDN_ENV === 'hw' ? css.SelectRoleLinkHw : ''}`} to={genLink('/select-role')}>{t('user-center.tab-role')}</Link>
            {!unlogin && <Button className={process.env.REACT_APP_IDN_ENV === 'hw' ? css.SelectRoleBtnHw : ''} color='primary' size='mini' fill='none' onClick={onBtnLogoutClick}>{t('user-center.login.login-out')}</Button>}
          </div>
        </div>

        <div className={css.PageBd}>
          {/* <TabBar className={css.TabBar} activeKey={activeGameCode} onChange={onTabClick}>
              {gameList.map(game => (
                <TabBar.Item key={game.gameCode} title={game.gameName} />
              ))}
            </TabBar> */}
          {
            process.env.REACT_APP_IDN_ENV !== 'hw' ? <div className={css.title}>{t('user-center.my-feedback')}</div> : null
          }

          {loading ? <AutoCenter><DotLoading color={'primary'} /></AutoCenter> : (
            <>
              <OrderList orderList={orderList} dealRedDotData={dealRedDotData} />
              <InfiniteScrollTem loadMore={getOrderList} hasMore={hasMore} />
            </>
          )}
        </div>

      </div>
    </UpdateOrderContext.Provider>
  )
})


const ORDER_STATUS_PENDING = 0; // 待处理(新工单 还未有任何回复)
const ORDER_STATUS_PROCESSING = 1; // 处理中
const ORDER_STATUS_RESOLVED = 2; // 已解决(待评价)
export const ORDER_STATUS_EVALUATED = 3; // 已评价
const ORDER_STATUS_FINISHED = 4; // 已完成


// 工单列表
export const OrderList: FC<{ orderList: any[], dealRedDotData: Function }> = ({ orderList, dealRedDotData }) => {
  const { t } = useTranslation();
  // 是否待处理(即是否需要展示下拉更多)
  const isPending = status => status === ORDER_STATUS_PENDING;
  // 当状态为待评价以上时展示评价栏
  const ScoreVisible = status => status >= ORDER_STATUS_RESOLVED;
  // 是否待评价
  const isResolved = status => status === ORDER_STATUS_RESOLVED;

  // 渲染评分
  const renderEvalStar = starNum => {
    return Array(5).fill(0).map((_, index) => <StarFill key={index} className={`${css.EvalStar} ${starNum > index ? css.Active : ''}`} />)
  }

  const rendArrow = (active, item: any) => {
    const { unRead } = item
    return active ? <div className={css.newReply}>{unRead === 0 && <span>{t('order.newReply')}</span>}<UpOutline fontSize={14} /></div> : <DownOutline fontSize={14} />
  }

  const sendReadRed = async (data: any) => {
    const { id, unRead } = data
    if (unRead === undefined || unRead === 1) return;

    const res = await workRead({ id })
    if (res?.code === 0) {
      dealRedDotData(id)
    }
  }

  const evalDom = (data: any) => {
    return <div className={css.ItemScore}>
        {isResolved(data.workOrderStatus) ? (
          <BtnEvalNew order={data} />
        ) : (
          renderEvalStar(data.starsNum)
      )}
    </div>
  }

  const workOrderReplyAgain = (data: any) => {
    const { workOrderReplyAgain, workOrderStatus } = data
    return workOrderReplyAgain.map((item, index) => {
      return <>
        <div className={css.ItemTitle}>
          <p>{item.workOrderDesc}</p>
          <span className={css.ItemTime}>{item.updateTime}</span>
        </div>
        <Collapse defaultActiveKey={['1']} className={css.ItemStatus}>
          <Collapse.Panel
            key={'1'}
            title={index === 0 ? data.workOrderStatusName : ''}
            disabled={isPending(item.workOrderStatus)}
            arrow={(active) => rendArrow(active, item)}
            onClick={() => { sendReadRed(item) }}
          >
            <div className={css.ItemMore}>
              {item.replyContents?.map(reply => (
                <div className={css.ItemAnswer} key={reply.updateTime}>
                  <div className={css.AnswerHd}><span>{t('user-center.cs-reply')}</span><span>{reply.updateTime}</span></div>
                  <div className={css.AnswerBd} style={{ whiteSpace: 'pre-line' }}>{reply.workOrderReply}</div>
                </div>
              ))}
              <div className={css.bottomBtn}>
                {index === 0 && item.replyFlag === 1 && <BtnReply order={data} />}
                {index === 0 && ScoreVisible(workOrderStatus) && evalDom(data)}
              </div>
            </div>
          </Collapse.Panel>
        </Collapse>
      </>
    })
  }
  
  if(process.env.REACT_APP_IDN_ENV === 'hw') {
    return (
      <div className={css.List}>
        {orderList?.map(order => (
          <div className={css.ListItem} key={order.id}>
            <div className={css.ItemHd}><span>{t('user-center.issue-order')}：{order.id}</span><span className={css.ItemHdR}>{order.addTime}</span></div>
            <div className={css.ItemUser}><span>{order.gameName}</span><span className={'mgl-10'}>{order.serverId}</span><span className={'mgl-10'}>{order.roleName}</span></div>
            {order?.workOrderReplyAgain.length > 0 && workOrderReplyAgain(order)}
            <pre className={css.ItemTitle}>{order.workOrderDesc}</pre>
            <Collapse defaultActiveKey={['1']} className={css.ItemStatus}>
              <Collapse.Panel
                key={'1'}
                title={order?.workOrderReplyAgain.length === 0 ? order.workOrderStatusName : ''}
                disabled={isPending(order.workOrderStatus)}
                arrow={(active) => rendArrow(active, order)}
                onClick={() => { sendReadRed(order) }}
              >
                <div className={css.ItemMore}>
                  {order.workOrderReply?.map(reply => (
                    <div className={css.ItemAnswer} key={reply.updateTime}>
                      <div className={css.AnswerHd}><span>{t('user-center.cs-reply')}</span><span>{reply.updateTime}</span></div>
                      <div className={css.AnswerBd} style={{ whiteSpace: 'pre-line' }}>{reply.workOrderReply}</div>
                    </div>
                  ))}
                  <div className={css.bottomBtn}>
                    {(order.probeFlag && order?.workOrderReplyAgain.length === 0 && (order.workOrderStatus === 1 || order.workOrderStatus === 2)) && <BtnReply order={order} />}
                    {ScoreVisible(order.workOrderStatus) && order?.workOrderReplyAgain.length === 0 && evalDom(order)}
                  </div>
                </div>
              </Collapse.Panel>
            </Collapse>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className={css.List}>
      {orderList?.map(order => (
        <div className={css.ListItem} key={order.id}>
          <div className={css.ItemHd}><span>{t('user-center.issue-order')}：{order.id}</span><span className={css.ItemHdR}>{order.addTime}</span></div>
          <div className={css.ItemUser}><span>{order.gameName}</span><span className={'mgl-10'}>{order.serverId}</span><span className={'mgl-10'}>{order.roleName}</span></div>
          <div className={css.ItemTitle}><QuestionCircleOutline className={css.QuestionIcon} /><pre>{order.workOrderDesc}</pre></div>
          <Collapse defaultActiveKey={['1']} className={css.ItemStatus}>
            <Collapse.Panel
              key={'1'}
              title={order.workOrderStatusName}
              disabled={isPending(order.workOrderStatus)}
              arrow={(active) => rendArrow(active, order)}
              onClick={() => { sendReadRed(order) }}
            >
              <div className={css.ItemMore}>
                {order.workOrderReply?.map(reply => (
                  <div className={css.ItemAnswer} key={reply.updateTime}>
                    <div className={css.AnswerHd}><span>{t('user-center.cs-reply')}</span><span>{reply.updateTime}</span></div>
                    <div className={css.AnswerBd} style={{ whiteSpace: 'pre-line' }}>{reply.workOrderReply}</div>
                  </div>
                ))}
                {ScoreVisible(order.workOrderStatus) && (
                  <div className={css.ItemScore}>
                    {isResolved(order.workOrderStatus) ? (
                      <BtnEval order={order} />
                    ) : (
                      renderEvalStar(order.starsNum)
                    )}
                  </div>
                )}
              </div>
            </Collapse.Panel>
          </Collapse>
        </div>
      ))}
    </div>
  )
}
